"use client";

import { useEffect } from "react";
import MenuTitle from "@/app/components/menuTitle";
import Fence from "./fence";
import { useTitleStore } from "@/stores";




const Page: React.FC = () => {
  const {setSelectedTitle} = useTitleStore();

  useEffect(() => {
    setSelectedTitle("UTM > 울타리침입시스템")
  }, [setSelectedTitle])

    return (
      <div>
        <MenuTitle/>
        <Fence/>
      </div>
    );
  };
  
  export default Page;